/**
 * botTint — a stable avatar colour for a bot.
 *
 * Bots have no colour stored on the backend; the workspace grid on `/customer`
 * historically tinted avatars by list position. That made the same bot a
 * different colour depending on where it sat in the list — and disagreed with
 * the (recency-sorted) sidebar. This derives the tint from the bot id instead,
 * so a bot keeps one colour everywhere it appears.
 *
 * Returns a tint class name from the `.av` / `.nav-av` palette in
 * `theme/soft.css` (empty string = the default pink gradient).
 */
export const BOT_TINTS = ['', 'mint', 'cream', 'violet', 'blue'] as const;

export type BotTint = (typeof BOT_TINTS)[number];

export function botTint(botId: string | undefined | null): BotTint {
  const id = (botId || '').trim();
  if (!id) return '';
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) {
    hash = (hash * 31 + id.charCodeAt(i)) | 0;
  }
  return BOT_TINTS[Math.abs(hash) % BOT_TINTS.length];
}
